import React from 'react';
import { LAST_UPDATED_COLUMN } from '../../../shared-constants';
import {
  formatCurrencyOnBlur,
  required,
  currencyFormatter,
} from '../../../../helpers/utils';
import EditAndDelete from '../../../../components/EditAndDelete';

export const FIELDS = [
  { label: 'Program Name', name: 'name', type: 'text' },
  { label: 'Short Description', name: 'short_desc', type: 'text' },
  {
    label: 'Lead Personnel',
    name: 'poc_name',
    type: 'dropdown',
    component: 'select',
  },
  {
    label: 'Current Budget',
    name: 'current_budget',
    type: 'money',
    transformOnBlur: formatCurrencyOnBlur,
  },
  {
    label: 'Annual Revenue',
    name: 'annual_revenue',
    type: 'money',
    transformOnBlur: formatCurrencyOnBlur,
  },
  { label: 'Expiration Date', name: 'expires', type: 'date' },
  {
    label: 'Problem Statement',
    name: 'problem_statement',
    type: 'text',
    multiline: true,
  },
  {
    label: 'Population Served',
    name: 'population_served',
    type: 'text',
    multiline: true,
  },
  {
    label: 'Current Constraints',
    name: 'current_constraints',
    type: 'text',
    multiline: true,
  },
  {
    label: 'Current Needs',
    name: 'current_needs',
    type: 'text',
    multiline: true,
  },
  { label: 'Inputs', name: 'inputs', type: 'text', multiline: true },
  { label: 'Partners', name: 'partners', type: 'text', multiline: true },
  { label: 'Outputs', name: 'outputs', type: 'text', multiline: true },
  { label: 'Impact', name: 'impact', type: 'text', multiline: true },
  { label: 'Notes', name: 'notes', type: 'text', multiline: true },
];

export const GRANT_SOURCES_COLUMNS = [
  { Header: 'Year', accessor: 'year' },
  {
    Header: 'Source',
    accessor: 'source',
  },
  {
    Header: 'Amount',
    accessor: 'amount',
    Cell: ({ cell: { value } }) => value && currencyFormatter.format(value),
    alignRight: true,
  },
  { ...LAST_UPDATED_COLUMN },
  {
    Header: '',
    accessor: 'handleDeleteFundingSource',
    Cell: (p) => <EditAndDelete alignRight {...p} />,
  },
];

export const GRANT_SOURCES_MODAL_FIELDS = [
  { name: 'year', label: 'Year', validate: required },
  { name: 'source', label: 'Source', validate: required },
  {
    name: 'amount',
    label: 'Amount',
    validate: required,
    transformOnBlur: formatCurrencyOnBlur,
  },
];

export const OUTCOMES_COLUMNS = [
  { Header: 'Item', accessor: 'item' },
  {
    Header: 'How Measured',
    accessor: 'how_measured',
  },
  {
    Header: 'Measurement',
    accessor: 'measurement',
  },
  { ...LAST_UPDATED_COLUMN },
  {
    Header: '',
    accessor: 'handleDeleteOutcome',
    Cell: EditAndDelete,
  },
];

export const OUTCOMES_MODAL_FIELDS = [
  { name: 'item', label: 'Item', validate: required },
  { name: 'how_measured', label: 'How Measured', validate: required },
  {
    name: 'measurement',
    label: 'Measurement',
    validate: required,
  },
];
